import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import BusinessRuleForm from "./BusinessRuleForm";
import BusinessRule, {
  IBusinessRule
} from "../../../model/evaluation/BusinessRule";

export interface State {}

export interface UpdateBusinessRuleFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  rowData: IBusinessRule;
}

class UpdateBusinessRuleForm extends React.Component<
  UpdateBusinessRuleFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler, rowData } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let updatedRecord;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          updatedRecord = BusinessRule(values);
          updatedRecord.id = rowData.id;
        }
      });
      return updatedRecord;
    });
  }

  render() {
    const { translate, rowData } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <BusinessRuleForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        rowData={rowData}
      />
    );
  }
}

export default UpdateBusinessRuleForm;
